import { useEffect, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { usePaymentExecution } from '../hooks/usePaymentExecution';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useContext(AuthContext);
  const { status, paymentInfo, execute } = usePaymentExecution(searchParams, refreshUser);

  useEffect(() => {
    execute();
  }, [execute]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] py-12 px-4" data-testid="payment-success-page">
      <div className="max-w-lg mx-auto">
        <Card className="card-surface border-[#27272A]">
          <CardContent className="py-12 text-center space-y-6">
            {status === 'loading' && (
              <>
                <Loader2 className="w-16 h-16 text-[#8B5CF6] mx-auto animate-spin" />
                <h2 className="text-2xl font-light" style={{ fontFamily: 'Outfit' }}>Processing payment...</h2>
              </>
            )}
            {status === 'success' && (
              <>
                <CheckCircle2 className="w-16 h-16 text-[#10B981] mx-auto" />
                <h2 className="text-2xl font-light" style={{ fontFamily: 'Outfit' }}>
                  {paymentInfo?.type === 'premium' ? 'Premium Activated!' : 'Thank You!'}
                </h2>
                <p className="text-[#A1A1AA]">
                  {paymentInfo?.type === 'premium'
                    ? 'Your 24-hour premium access is now active. Enjoy unlimited topics!'
                    : 'Your donation has been received. Thank you for supporting mental health initiatives!'}
                </p>
              </>
            )}
            {status === 'pending' && (
              <>
                <Loader2 className="w-16 h-16 text-[#D4AF37] mx-auto" />
                <h2 className="text-2xl font-light" style={{ fontFamily: 'Outfit' }}>Payment Processing</h2>
                <p className="text-[#A1A1AA]">Your payment is being processed. This may take a moment.</p>
              </>
            )}
            {status === 'error' && (
              <>
                <XCircle className="w-16 h-16 text-[#EF4444] mx-auto" />
                <h2 className="text-2xl font-light" style={{ fontFamily: 'Outfit' }}>Something went wrong</h2>
                <p className="text-[#A1A1AA]">We couldn't process your payment. Please try again or contact support.</p>
              </>
            )}
            <Button onClick={() => navigate('/')} className="btn-purple rounded-full px-8" data-testid="back-home-button">
              Back to Home
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
